module.exports = __webpack_public_path__ + "images/init-weekly-reports-64be7c63263cfd48a8f1c8637da0edec.png";